import reframe from 'nike-re-framejs';
import Immutable from 'immutable';
import { pushClient } from '@/services/push';
import { betslipSubmittedPush$ } from './command';
import { isLoggedIn } from '@/account';
import { map, tap, distinctUntilChanged } from 'rxjs/operators';

export default function startBetslipPush() {
    const betRefreshSubscription = pushClient.subscription({
        onMessage: () => reframe.dispatch(['cmd', ['RefreshBetslip', {}]])
    });

    if (isLoggedIn()) {
        pushClient
            .subscription({
                onMessage: data => {
                    betslipSubmittedPush$.next(data);
                }
            })
            .resetPushPaths(['/user-betslip/mobile/']);
    }

    reframe.db$
        .pipe(
            map(betslip => {
                const betPaths = betslip
                    .getIn(['server', 'betslip', 'betIds'], Immutable.List())
                    .filter(id => id[0] !== 'p')
                    .map(id => getBetPath(id))
                    .toSet();
                const matchPaths = betslip
                    .getIn(['server', 'betslip', 'betEventIds'], Immutable.List())
                    .filter(id => id[0] !== 'p')
                    .map(id => getMatchPath(id))
                    .toSet();
                return betPaths.concat(matchPaths);
            }),
            distinctUntilChanged(),
            tap(ids => {
                const idsArray = ids.toArray();
                betRefreshSubscription.resetPushPaths(idsArray);
            }),
            tap(null, e => console.error(e))
        )
        .subscribe();
}

const normalizeId = id => (id.match(/^[a-zA-Z]/) ? id.substr(1) : id);

function getBetPath(betId) {
    if (betId[0] !== 'l') {
        return '/n1/betslip/bet/' + normalizeId(betId) + '/';
    }
}

function getMatchPath(matchId) {
    return '/n1/betslip/match/' + matchId + '/';
}
